import React from "react";
import { IconButton } from "../button";
import { Input, TextInputProps } from "./input";
import { HiEye } from "react-icons/hi";

export function PasswordInput({ wrapperRef, ...props }: TextInputProps) {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <Input
      wrapperRef={wrapperRef}
      {...props}
      type={showPassword ? "text" : "password"}
      append={
        <IconButton
          onPress={() => setShowPassword((p) => !p)}
          size="sm"
          variant="light"
        >
          <HiEye size={16} />
        </IconButton>
      }
    ></Input>
  );
}
